// -------------------------------------------------------------
//  State
// -------------------------------------------------------------

const state = {
	user : {},
	orgs : [],
	active_org_id: '',
	initialised: false,
	token: '',
};

// -------------------------------------------------------------
//  Getters
// -------------------------------------------------------------

const getters = {
	is_admin : state => (state.user||{}).is_admin,
	is_logged_in : state => state.token && (state.user||{}).id,
	active_org : state => state.orgs.find(o=>o.id==state.active_org_id) || null,
}


// -------------------------------------------------------------
//  Actions
// -------------------------------------------------------------

const actions = {

	check({ dispatch , getters }){
		return dispatch('init').then(function(){
			return getters.is_logged_in ;
		});
	},

	checkAdmin({ dispatch , getters }){
		return dispatch('check').then(function(is_logged_in){
			return is_logged_in && getters.is_admin ;
		});
	},

	init({ commit , state , dispatch , getters }){
		if(!state.initialised){
			return dispatch('restore').then(function(){
				commit('setInitialised',true);
			})
			.catch(function(error){
				console.error( error || 'Failed to restore user - logging out');
				return dispatch('clearLocalAuthData');
			})
			.then(function(){
				return getters.is_logged_in ;
			});
		} else {
			return new Promise(function(resolve,reject){ resolve(getters.is_logged_in ); });
		}
	},


	restore({ dispatch , commit }){
		return new Promise(function(resolve,reject){

			var token = window.localStorage.getItem('token');
			if(!token) return resolve();

			commit('setApiToken', token );

			dispatch('refreshUserAndOrgs').then(({user,orgs})=>{
				dispatch('restoreActiveOrg');
				resolve();
			}).catch(function(e){
				reject(e);
			})

		});
	},


	processUserLoginResponse({ dispatch , commit } , response ){

		let token = response.accessToken;
		let user = response.user;
		let orgs = response.orgs;

		commit('setApiToken', token );
		commit('setUser', user );
		commit('setOrgs', orgs );
		dispatch('restoreActiveOrg');

		Event.$emit('userLoggedIn');

	},

	login({ dispatch , commit } , creds ){
		return api.call('post','/login',creds).then(({data}) => {
			 dispatch('processUserLoginResponse',data);
		});
	},


	restoreActiveOrg({ dispatch , commit , state }){

		if(state.active_org_id) return;
		if(!state.orgs.length) return;
		let active_org = state.orgs.map(a=>a).sort((a,b)=>{
					if(a.name==b.name) return 0;
					if(a.name<b.name) return 1;
					return -1;
				})[0];

		commit('setActiveOrgId', active_org.id );

	},


	register({ dispatch , commit } , data ){
		return api.call('post','/register',data).then(({data}) => {
			 dispatch('processUserLoginResponse',data);
		});
	},


	refreshUserAndOrgs({dispatch},){
		return dispatch('refreshUser',true);
	},

	updateUser({commit,state}, data ){
		return api.call('put','/users/me',data).then( ({data}) => {
					if(!data.id){
						throw 'Invalid user data provided from server';
					}
					commit('setUser', data );
					return data;
				});
	},

	addOrg({commit,state}, payload ){
		return api.store('org',payload).then( org => {
					commit('setOrg', org );
					return org;
				});
	},

	updateOrg({commit,state}, {id,payload} ){
		return api.update('org',id,payload).then( org => {
					commit('setOrg', org );
					return org;
				});
	},

	refreshUser({commit}, and_orgs = false ){
		return api.call('get','/users/me',null,{no_redirect:true}).then(({data}) => {
			let user = data.user;
			if(!user.id){
				throw new Error('Invalid user data provided from server');
			}

			commit('setUser', user );

			if(and_orgs){
				let orgs = data.orgs || [];
				commit('setOrgs', orgs );
				return {
					user,
					orgs
				};
			}

			return user;
		});
	},

	refreshOrgs({commit}){
		return api.call('get','/orgs').then(({data}) => {
			commit('setOrgs', data );
			return data;
		});
	},


	clearLocalAuthData({ commit , getters , state }){
		commit('setApiToken',null);
		commit('setUser', null);
		commit('setOrgs', null);
	},

	logout({ dispatch }){
		return api.call('post','/logout').then(function(){
			dispatch('clearLocalAuthData')
		});
	},


	switchActiveOrgIfNeeded( { commit , dispatch , getters , state } , target_org_id ){
		if( state.active_org_id && (target_org_id == state.active_org_id) ){
			return new Promise(function(resolve,reject){ resolve( getters.active_org ); });
		} else {
			return dispatch('switchActiveOrg',target_org_id);
		}
	},


	switchActiveOrg( {state , dispatch,commit} , target_org_id){
		return dispatch('refreshOrgs').then(function(orgs){
			var org = orgs.find(e=>e.id==target_org_id);
			if(org){
				commit('setActiveOrgId',target_org_id);
				api.call('post','/me',{'touch-org':target_org_id});
				return org;
			}
			return null;
		})
	},

}


// -------------------------------------------------------------
//  Mutations
// -------------------------------------------------------------

const mutations = {

	setUser(state, user) {
		state.user = user;
	},

	setOrgs(state, orgs) {
		state.orgs = orgs;
	},

	setOrg(state, org) {
		state.orgs = api.mergeResult(state.orgs,org);
	},

	setApiToken (state, token) {
		state.token = token || '';
		window.localStorage.setItem('token', token || ''); // Note - passing 'null' here will convert to (str) "null"
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	},

	setActiveOrgId (state, id) {
		state.active_org_id = id;
	},

	setInitialised (state, initialised ) {
		state.initialised = initialised || false;
	},


}


// -------------------------------------------------------------
//  Export
// -------------------------------------------------------------

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}